import * as vp from 'vopay';
import React, { FunctionComponent, useEffect, useState } from 'react';
import styles from './VideoContainer.module.scss';

type VideoSearchFormProps = {
  videos: vp.VideoObject[];
  filteredByKeyWordLists: { [key: string]: vp.VideoObject };
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  setFilteredByKeyWordLists: (video: { [key: string]: vp.VideoObject }) => void;
  getSelectedVideo: (video: vp.VideoObject) => void;
  setHasSearchResult: (e: boolean) => void;
};

type FC = FunctionComponent<VideoSearchFormProps>;

const { TextField, Button, Icon } = vp;

const VideoSearchForm: FC = (props: VideoSearchFormProps) => {
  const {
    videos,
    filteredByKeyWordLists,
    searchTerm,
    setSearchTerm,
    setFilteredByKeyWordLists,
    getSelectedVideo,
    setHasSearchResult,
  } = props;
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredByKeyWordLists({});
    } else {
      const filtered = (videos || [])
        .filter((video) => video.title.toLowerCase().includes(searchTerm.toLowerCase()))
        .reduce(
          (accumulator, video, index) => ({
            ...accumulator,
            [index]: { ...video },
          }),
          {},
        );
      setFilteredByKeyWordLists(filtered);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === '') {
      setHasSearchResult(false);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (Object.values(filteredByKeyWordLists).length !== 0) {
      setIsMenuVisible(true);
    } else {
      setIsMenuVisible(false);
    }
  }, [filteredByKeyWordLists]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const button = document.getElementById('search-tutorial-btn');
      button?.click();
    }
  };

  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchInput}>
        <TextField
          name="video-search"
          elementLeft={<Icon icon="search" color="primary-dark-transparent" width="18px" height="18px" />}
          value={searchTerm}
          onBlur={() => {}}
          onKeyPress={handleKeyPress}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
        />
        {isMenuVisible && (
          <div className={styles.listContainer}>
            {Object.values(filteredByKeyWordLists).map((video, index) => {
              const title = video.title;
              const lowerSearchTerm = searchTerm.toLowerCase();
              const indexOfMatch = title.toLowerCase().indexOf(lowerSearchTerm);

              if (indexOfMatch !== -1) {
                const beforeMatch = title.substring(0, indexOfMatch);
                const match = title.substring(indexOfMatch, indexOfMatch + lowerSearchTerm.length);
                const afterMatch = title.substring(indexOfMatch + lowerSearchTerm.length);
                return (
                  <div
                    key={index}
                    className={styles.selectOption}
                    onClick={() => {
                      getSelectedVideo(video);
                      setIsMenuVisible(false);
                    }}
                  >
                    {beforeMatch}
                    <strong>{match}</strong>
                    {afterMatch}
                  </div>
                );
              } else {
                return (
                  <div
                    key={index}
                    className={styles.selectOption}
                    onClick={() => {
                      getSelectedVideo(video);
                      setIsMenuVisible(false);
                    }}
                  >
                    {title}
                  </div>
                );
              }
            })}
          </div>
        )}
      </div>
      <Button
        id="search-tutorial-btn"
        label="Search"
        width="78px"
        height="40px"
        color="yellow"
        type="submit"
        onClick={() => {
          setHasSearchResult(true);
          setIsMenuVisible(false);
        }}
      />
    </div>
  );
};

export default VideoSearchForm;
